import React from 'react';

import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';

import {
  LOGIN_GOOGLE_PRIVACY_POLICY,
  LOGIN_GOOGLE_TERMS_AND_CONDITIONS,
  NO_FOOTER_ROUTES
} from '../../../constants/auth';
import { TRANSLATIONS_GLOBAL } from '../../../translations/commons';
import { redirectToPage } from '../../../utils/utils';
import './Footer.scss';

interface FooterProps {
  dashboard?: boolean;
  login?: boolean;
}

const Footer = ({ dashboard, login }: FooterProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const handleRedirect = (url: string) => {
    redirectToPage(navigate, url);
  };

  const handleKeyPress = (event: React.KeyboardEvent<HTMLButtonElement>, url: string) => {
    if (event.key === 'Enter' || event.key === ' ') {
      handleRedirect(url);
    }
  };

  if (NO_FOOTER_ROUTES.includes(location.pathname)) {
    return null;
  }

  return (
    <footer className={dashboard ? 'footer-dashboard-container-v3' : 'footer-container-v3'}>
      <div className="footer-text-v3">
        {!login && (
          <>
            {t(TRANSLATIONS_GLOBAL.copyright)}
            <button
              className="footer-text-v3 termns-and-conditions"
              tabIndex={0}
              onClick={() => handleRedirect(LOGIN_GOOGLE_TERMS_AND_CONDITIONS)}
              onKeyDown={(e) => handleKeyPress(e, LOGIN_GOOGLE_TERMS_AND_CONDITIONS)}
            >
              {t(TRANSLATIONS_GLOBAL.termsAndConditions)}
            </button>
            <button
              className="footer-text-v3 policies-and-privacy"
              tabIndex={0}
              onClick={() => handleRedirect(LOGIN_GOOGLE_PRIVACY_POLICY)}
              onKeyDown={(e) => handleKeyPress(e, LOGIN_GOOGLE_PRIVACY_POLICY)}
            >
              {t(TRANSLATIONS_GLOBAL.privacyPolicy)}
            </button>
          </>
        )}
        {login && (
          <div className="google-policies-texts">
            <div className="text-container">{t(TRANSLATIONS_GLOBAL.recaptcha)}</div>
            <button
              className="google-policies-texts policies-and-privacy"
              tabIndex={0}
              onClick={() => handleRedirect(LOGIN_GOOGLE_PRIVACY_POLICY)}
              onKeyDown={(e) => handleKeyPress(e, LOGIN_GOOGLE_PRIVACY_POLICY)}
            >
              {t(TRANSLATIONS_GLOBAL.privacyPolicy)}
            </button>
            <button
              className="google-policies-texts termns-and-conditions"
              tabIndex={0}
              onClick={() => handleRedirect(LOGIN_GOOGLE_TERMS_AND_CONDITIONS)}
              onKeyDown={(e) => handleKeyPress(e, LOGIN_GOOGLE_TERMS_AND_CONDITIONS)}
            >
              {t(TRANSLATIONS_GLOBAL.termsAndConditions)}
            </button>
          </div>
        )}
      </div>
    </footer>
  );
};

export default Footer;
